import { render } from "./TermsOfServiceContent.vue?vue&type=template&id=202980a3&scoped=true"
import script from "./TermsOfServiceContent.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceContent.vue?vue&type=script&lang=js"

import "./TermsOfServiceContent.vue?vue&type=style&index=0&id=202980a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202980a3"]])

export default __exports__